import { useEffect } from "react";
import { useState } from "react";
import Iframe from "react-iframe";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../../api/api";
import Images from "../../../media/images";

const Videos = () => {
  // const gallery = useSelector((state) => state.gallery);
  // const [fetchVideos, setfetchVideos] = useState([]);
  // // console.log("videos", gallery);

  // useEffect(() => {
  //   gallery.data?.map((item, index) => {
  //     if (item["media_type"] === "VI") {
  //       // console.log("video check", item);
  //       setfetchVideos((fetchVideos) => [...fetchVideos, item]);
  //     }
  //     // console.log("data fetched");
  //   });
  // }, []);
  const [gallery, setGallery] = useState([]);
  const [imgLink, setImgLink] = useState("");
  const [categories, setCategories] = useState()
  const [categoryName, setCategoryName] = useState([])
  

  useEffect(() => {
 
    api
    .get("/gallery/media/?media_type=VI")

    .then((resp)=>{
      setGallery(resp.data)
    })
    .catch((error)=>{
      toast("Something went wrong")
    })
    
    
    }, [])
    useEffect(() => {
     
      api
  .get("/gallery/media/categories/")

      .then((resp)=>{
        setCategoryName(resp.data)
      })
      .catch((error)=>{
        toast("Something went wrong")
      })
      
      
      }, [])
    

  return (
    <div>
      <div className="mt-10">
        {/* <div className="animation mt-8 flex flex-wrap items-center justify-center gap-6 bg-white">
          {fetchVideos?.map((value, index) => {
            return (
              <Link
                key={index}
                to={`${value.album_title?.replace(" ", "-")}`}
                className=""
              >
              
              </Link>
            );
          })}
        </div> */}

        {/* videos */}
        <div className="animation block flex-wrap items-center justify-center gap-6 bg-white">
          <div className="text-center">
          <div className=" flex justify-center gap-3">
     {

categoryName?.map((item,index)=>{
  return(


<div onClick={()=>setCategories(item.name)} className="bg-primary-red text-white-3 rounded-xl  text-white text-2xl p-2 cursor-pointer">{item.name}</div>
  )
})
     }     
   </div>
            <div className="mt-4">
              <img alt="" src={Images.title_border} className="mx-auto" />
            </div>
          </div>
          <div className="px-10 py-10">
            <div className="grid grid-cols-1 items-center justify-center gap-7 text-white sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 ">
              {gallery?.filter((value)=>value.category.name===categories).map((item, index) => {
                console.log("Videos",item);


                return (
                  <div key={index} className=" ">
                    {/* <Link
                      key={index}
                      to={`${item.album.replace(" ", "-")}`exampleModalGallery}
                      className=""
                    > */}
                    <div
                      // to={`${item.album_title.replace(" ", "-")}`}
                      className=" flex flex-col-2 gap-2 "
                    >
                      {/* <video className="w-72 h-60" controls> */}
                      {/* {value.id} */}
                      {/* <source
                          src="https://archive.org/download/BigBuckBunny_124/Content/big_buck_bunny_720p_surround.mp4"
                          type="video/mp4"
                        /> */}
                      {/* <source src={item.video_url} type="video/mp4" />
                        <source src={item.video_url} type="video/ogg" />
                      </video> */}
                      <iframe

                        width="460"
                        height="265"
                        src={item.video_url}
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      />


                    </div>
                    {/* </Link> */}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="font-Berkshire mt-5 flex justify-center">
            <div
              // to={`${value.id.replace(" ", "-")}`}
              className="!bg-primary-red rounded-full py-1 px-2 text-white"
            >
              View More
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Videos;
